// Filter bundles by a boolean attribute (isSettled, isActive).
export const filterBundlesByAttribute = (bundles, attribute) => {
	const filteredBundles = Object.values(bundles)
		.filter(bundle => bundle[attribute] && bundle.products?.length > 0);

	if (filteredBundles.length === 0) return [];

	return filteredBundles.map(bundle => ({
		title: bundle.title,
		products: bundle.products
	}));
};

/* Filter product based on tags and bundles.
 Filter product if product tags includes every chosen filter tag or is part of a chosen bundle */
export const filterProducts = (products, tags, bundleProducts) =>
	products?.filter(product => {
		const inBundle =
			!bundleProducts?.length || bundleProducts.some(b => b.id === product.id);
		const hasTags =
			tags.every(tag => product.tags?.includes(tag));

		return inBundle && hasTags;
	});


/* Iterate through collections and get the total number of products */
export const countProducts = (collections) => {
	const allProducts = Object.values(collections)
		.flatMap(c => c.products || []);

	return new Set(allProducts.filter(Boolean)).size;
};


/* Get distinct product tags */
export const getAllProductTags = (products) =>
	[... new Set(products?.map(f => f.tags).flat())].filter(Boolean);

/* Get all chosen filter tags known as activeTags  or settledTags*/
export const filterTagsByAttribute = (tags, attribute) => {
	if (!tags || !Object.keys(tags).length) return [];
	return Object.entries(tags)
		.map(([tag, attrs]) => attrs[attribute] ? tag : false)
		.filter(Boolean);
};

/* Get all remaining products and tags in a single iteration */
export const getRemainingProductsAndTags = (collections) => {
	const productsSet = new Set();
	const tagsSet = new Set();

	for (const { products = [], tags = [] } of Object.values(collections)) {
		for (const product of products) productsSet.add(product);
		for (const tag of tags) tagsSet.add(tag);
	}

	return {
		remainingProducts: Array.from(productsSet),
		remainingTags: Array.from(tagsSet),
	};
};

/* Map filter tags to an array of objects of the { tag: { displayName, isActive}} */
export const mapFilterTags = (filters) =>
	Object.fromEntries(
		filters.filter(d => d._type !== "bundlesFilter").flatMap(f => f.data)
			.map(d => [d.tag, {
				displayName: d.displayName,
				isActive: false,
				isSettled: false
			}])
	);


/* Map filter bundles to an array of objects of the { title: { products, isActive, isSettled, title }} */
export const mapFilterBundles = (filters) =>
	Object.fromEntries(
		filters.filter(d => d._type === "bundlesFilter").flatMap(b => b.data)
			.map(d => [d.title, {
				products: d.products,
				isActive: false,
				isSettled: false,
				title: d.title
			}])
	);

/* Get total number of filters chosen by user (active filters) */
export const getNumberOfSettledFilters = (tags) => Object.values(tags).filter(tag => tag.isSettled).length;
